"use client";

import { usePathname } from "next/navigation";

export const useCreateIntlPath = (route: string) => {
  const pathname = usePathname() || "";

  return `${pathname.slice(0, 3)}${route}`;
};
